import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Range.scss';
import ToolTip from '../ToolTip/ToolTip';

const Range = (props) => {
  const {
    id,
    value,
    handler,
    label,
    rangeMin,
    rangeMax,
    rangeStep,
    description,
    tooltip,
    ariaControls,
    hasSupportingInfoBelow,
    disabled,
    isSpecial,
    lessThan,
  } = props;

  const [workingValue, setWorkingValue] = useState(value);
  const [prevValue, setPrevValue] = useState(null);

  if (value !== prevValue) {
    setWorkingValue(value);
    setPrevValue(value);
  }

  return (
    <div
      className="Range form-group"
      style={{
        color: '#73767B',
        marginTop: '30px',
        marginBottom: hasSupportingInfoBelow ? '5px' : '30px',
      }}
    >
      <label className="label-style" htmlFor={id}>
        {!isSpecial ? label : null}
        {tooltip && <ToolTip message={tooltip} id={id + '_tooltip'} />}
      </label>
      <input
        type="range"
        id={id}
        className="form-control-range input-range"
        value={workingValue}
        min={rangeMin}
        max={rangeMax}
        step={rangeStep}
        disabled={disabled}
        aria-label={label}
        aria-controls={ariaControls}
        onChange={(e) => setWorkingValue(e.target.value)}
        onMouseUp={(e) => handler(e)}
        onTouchEnd={(e) => handler(e)}
      />
      {lessThan ? (
        <p className="mb-0  description">
          {'< '}
          {description(workingValue)}
        </p>
      ) : (
        <p className="mb-0  description">{description(workingValue)}</p>
      )}
    </div>
  );
};

export default Range;

Range.propTypes = {
  id: PropTypes.string,
  value: PropTypes.number,
  handler: PropTypes.func,
  label: PropTypes.string,
  rangeMin: PropTypes.number,
  rangeMax: PropTypes.number,
  rangeStep: PropTypes.number,
  description: PropTypes.func,
  disabled: PropTypes.bool,
  hasSupportingInfoBelow: PropTypes.bool,
  ariaControls: PropTypes.string,
  tooltip: PropTypes.string,
};
